import React from 'react';

interface DifficultySelectionModalProps {
  onSelectDifficulty: (difficulty: 'Easy' | 'Medium' | 'Hard') => void;
  onClose: () => void;
}

const DifficultySelectionModal: React.FC<DifficultySelectionModalProps> = ({ onSelectDifficulty, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-white p-8 rounded-lg shadow-xl text-center max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
        <div className="text-5xl mb-2">🏎️</div>
        <h2 className="text-2xl font-bold text-gray-800 mb-1">Choose Your Difficulty</h2>
        <p className="text-sm text-gray-500 mb-6">Faster opponents push your speed -- pick the challenge that fits you.</p>
        <div className="space-y-3">
          <button
            onClick={() => onSelectDifficulty('Easy')}
            className="w-full px-6 py-3 bg-green-500 text-white rounded-lg font-semibold text-lg hover:bg-green-600 transition-colors flex items-center justify-between px-6"
          >
            <span>Easy</span><span className="text-sm font-normal opacity-90">~20-30 WPM</span>
          </button>
          <button
            onClick={() => onSelectDifficulty('Medium')}
            className="w-full px-6 py-3 bg-yellow-500 text-white rounded-lg font-semibold text-lg hover:bg-yellow-600 transition-colors flex items-center justify-between px-6"
          >
            <span>Medium</span><span className="text-sm font-normal opacity-90">~35-45 WPM</span>
          </button>
          <button
            onClick={() => onSelectDifficulty('Hard')}
            className="w-full px-6 py-3 bg-red-500 text-white rounded-lg font-semibold text-lg hover:bg-red-600 transition-colors flex items-center justify-between px-6"
          >
            <span>Hard</span><span className="text-sm font-normal opacity-90">~50-60 WPM</span>
          </button>
        </div>
        <button onClick={onClose} className="mt-6 text-gray-500 hover:underline">Cancel</button>
      </div>
    </div>
  );
};

export default DifficultySelectionModal;
